// Regex, not `new URL()`: Hermes' URL polyfill leaves hostname/pathname empty.
const MEET_URL_PATTERN =
  /^(?:https?:\/\/)?(?:www\.)?meet\.google\.com\/([^/?#]+)/i;
// Meet publishes the code in a fixed xxx-xxxx-xxx shape; anything else on that host is a redirect
const MEET_CODE_PATTERN = /^[a-z]{3}-[a-z]{4}-[a-z]{3}$/i;

// Only Meet publishes a readable code; a Teams or Zoom id is opaque, so those get nothing.
export const getVideoCallMeetingCode = (url: string): string | null => {
  const code = url.trim().match(MEET_URL_PATTERN)?.[1];

  return code && MEET_CODE_PATTERN.test(code) ? code : null;
};
